import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { adminApiClient } from "../../services/apiClient";
import { toApiError } from "../../types/api";

import type { ContactSettings } from "@lingoshade/domain";

interface ContactState {
  settings: ContactSettings | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
}
export const fetchContactSettings = createAsyncThunk<
  ContactSettings,
  void,
  { rejectValue: string }
>(
  "contactSettings/fetch",
  async (
    _,
    { rejectWithValue },
  ): Promise<ContactSettings | ReturnType<typeof rejectWithValue>> => {
    try {
      return (
        await adminApiClient.get<ContactSettings>("/admin/contact-settings")
      ).data;
    } catch (error: unknown) {
      return rejectWithValue(toApiError(error).message);
    }
  },
);
export const saveContactSettings = createAsyncThunk<
  ContactSettings,
  ContactSettings,
  { rejectValue: string }
>(
  "contactSettings/save",
  async (
    settings,
    { rejectWithValue },
  ): Promise<ContactSettings | ReturnType<typeof rejectWithValue>> => {
    try {
      return (
        await adminApiClient.put<ContactSettings>(
          "/admin/contact-settings",
          settings,
        )
      ).data;
    } catch (error: unknown) {
      return rejectWithValue(toApiError(error).message);
    }
  },
);
const initialState: ContactState = {
  settings: null,
  loading: false,
  saving: false,
  error: null,
};
const slice = createSlice({
  name: "contactSettings",
  initialState,
  reducers: {},
  extraReducers: (builder): void => {
    builder
      .addCase(fetchContactSettings.pending, (state): void => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactSettings.fulfilled, (state, action): void => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchContactSettings.rejected, (state, action): void => {
        state.loading = false;
        state.error = action.payload ?? null;
      })
      .addCase(saveContactSettings.pending, (state): void => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveContactSettings.fulfilled, (state, action): void => {
        state.saving = false;
        state.settings = action.payload;
      })
      .addCase(saveContactSettings.rejected, (state, action): void => {
        state.saving = false;
        state.error = action.payload ?? null;
      });
  },
});
export default slice.reducer;
